module.exports = __webpack_public_path__ + "static/media/emre.d7668aeb.jpg";